import { numberFormat, percentageFormat } from 'components/Number';
import { firstOfMonthIn, monthName } from 'helpers/dateHelper';
import { resolveMarketingPlanMonths } from './cashflowMarketingPlanMonths';

const MARKETING_TABLE_HEADERS = [
  'Month',
  'Marketing',
  'Funding %',
  'Funding',
  '% Revenue Share',
  '% Revenue Share To Collect',
];

function csvCell(value) {
  if (value == null) {
    return '';
  }
  return value;
}

/**
 * Builds CSV rows for the marketing plan section (summary + table).
 * @param {Record<string, unknown>} formValues
 * @returns {string[][]}
 */
export function buildMarketingPlanCsvSection(formValues) {
  const monthCount = resolveMarketingPlanMonths(formValues?.marketingPlanMonths);
  const rows = [
    ['Marketing plan length (months)', String(monthCount)],
    ['Marketing Factor', csvCell(percentageFormat(formValues?.mfFactor))],
    ['Default %', csvCell(percentageFormat(formValues?.mfDefaultPercent))],
    ['Revenue Factor', csvCell(percentageFormat(formValues?.mfRevenueFactor))],
    [''],
    MARKETING_TABLE_HEADERS,
  ];

  for (let monthIndex = 0; monthIndex < monthCount; monthIndex += 1) {
    rows.push([
      `${monthName(firstOfMonthIn(monthIndex))} (Mob ${monthIndex})`,
      csvCell(numberFormat(formValues?.[`mob${monthIndex}Marketing`])),
      csvCell(percentageFormat(formValues?.[`mob${monthIndex}PercentOfMarketing`])),
      csvCell(numberFormat(formValues?.[`mob${monthIndex}Funding`])),
      csvCell(percentageFormat(formValues?.[`mob${monthIndex}RevenueShare`])),
      csvCell(percentageFormat(formValues?.[`mob${monthIndex}RevenueShareToCollect`])),
    ]);
  }

  return rows;
}

export { MARKETING_TABLE_HEADERS };
